import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Logo from 'common/components/UIElements/Logo';
import Container from 'common/components/UI/Container';
import LogoImage from 'common/assets/image/appModern/logo.png';
import FooterArea, {
  MenuArea,
  Menu,
  MenuItem,
  CopyrightText,
} from './footer.style';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      appModernJson {
        footer {
          menu {
            id
            link
            text
          }
        }
      }
    }
  `);
  const { menu } = data.appModernJson.footer;
  const date = new Date();
  const year = date.getFullYear();

  return (
    <FooterArea id="footer">
      <Container>
        {/* End of footer widgets area */}
        <MenuArea>
          <Logo
            className="logo"
            href="#home"
            logoSrc={LogoImage}
            title="App Classic"
          />
          <Menu>
            {menu.map((item) => (
              <MenuItem key={`footer-link${item.id}`}>
                <a href={item.link}>{item.text}</a>
              </MenuItem>
            ))}
          </Menu>
          <CopyrightText>Copyright {year} PraktijkCipres.nl</CopyrightText>
        </MenuArea>
        {/* End of footer menu area */}
      </Container>
    </FooterArea>
  );
};

export default Footer;
